import React from 'react';
import { DialogActions } from '@material-ui/core';
import PropTypes from 'prop-types';

function AmberDialogActions(props) {
  const { children, classes } = props;

  return (
    <DialogActions {...(classes ? { classes } : {})} id="form-dialog-title">
      {children}
    </DialogActions>
  );
}
AmberDialogActions.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string),
};
AmberDialogActions.defaultProps = {
  classes: null,
};
export default AmberDialogActions;
